/**
 * URL de base de l'API backend.
 * - Si VITE_API_URL est défini, on l'utilise.
 * - Sinon en dev (Vite) ou quand l'app est servie sur localhost, on cible http://localhost:8000
 *   pour éviter que les requêtes aillent vers le frontend (404 sur /api/accounts/login, /api/public/audit, etc.).
 */
export function getApiBaseUrl() {
  const explicit = import.meta.env.VITE_API_URL;
  if (explicit && String(explicit).trim()) return String(explicit).trim();
  const port = import.meta.env.VITE_API_PORT || 8000;
  const devBackend = `http://localhost:${port}`;
  if (import.meta.env.DEV) return devBackend;
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) return devBackend;
  return '';
}

export const API_BASE_URL = getApiBaseUrl();
